import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store/index';
import { getAllRoutes } from '@/routeConfig';
import { getLocale, setLocale } from '@/i18n/index';

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	scrollBehavior: (to, from, savedPosition) => savedPosition ? savedPosition : { left: 0, top: 0 },
	routes: getAllRoutes(),
});

//base: '/de',
router.beforeEach((to, from, next) => {

	// const lang = to.params.lang;
	if (to !== undefined && to.meta !== undefined && to.meta.disallowAuth && store.state.isLoggedIn) {

		// if user came from router-link
		if (from.name) return next(false);

		// if user navigated the site manually / from outside
		return next({ name: 'CorporateData' });
	}
	const localeUrlSegment = to.path.split('/'),
		currentLocale = getLocale();

	// Get locale from path
	localeUrlSegment.shift();
	const locale = localeUrlSegment[0] === '' ? currentLocale : localeUrlSegment[0];

	// Set locale
	setLocale(locale);
	to.params.locale = locale;

	return next();
});

export default router;
